module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-refresh-arrows.a660b06c.svg";